import {BusinessUnitScenario} from './BusinessUnitScenario';
import {VisionDuplicationScenario} from '../../../allkeyme/vision/parameters/VisionDuplicationScenario';

export class BusinessUnitDuplicationScenario extends BusinessUnitScenario {
duplicateActions: boolean | null;
duplicateBusinessUnit: boolean | null;
duplicateChronoCodes: boolean | null;
duplicateFeatures: boolean | null;
duplicateFormats: boolean | null;
duplicateFreeDatas: boolean | null;
duplicateProfiles: boolean | null;
duplicateRoles: boolean | null;
duplicateUsers: boolean | null;
duplicateVisions: boolean | null;
originBusinessUnitCode: string;
visionScenario: VisionDuplicationScenario;
}

